import React from "react";
import PropTypes from "prop-types";

function ChatFooter({ chatBotSetting }) {
  
  return (
    <div
      style={{
        backgroundColor: chatBotSetting.headerBackgroundColor,
      }}
      className="flex items-center justify-center w-full p-2.5"
    >
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 inline-flex items-center justify-center bg-white md:bg-gray-100 rounded-full">
          <img
            src=""
            alt="logo"
            className="w-full h-full object-contain hidden"
          />
        </div>
        <p className="text-[0.8em] text-white font-light tracking-wide">
          Powered by{" "}
          <a
            href="https://www.botcircuits.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white underline"
          >
            BotCircuits
          </a>
        </p>
      </div>
    </div>
  );
}

ChatFooter.propTypes = {
  chatBotSetting: PropTypes.any,
};

export default ChatFooter;
